import { useContext, useEffect, useState } from "react";
import { regexService, templateService } from "../../service";
import { loaderContext, notificationContext } from "../../context/context";
import dateFormat from "../../utils/dateFormat";
import { useModal } from "../../hooks";
import { Modal } from "../../components";

function EmailList() {
  const toast = useContext(notificationContext);
  const templateModal = useModal();
  const previewModal = useModal();

  const [isLoading, setLoading] = useState(true);

  const [emailData, setEmailData] = useState([]);
  const [templateData, setTemplateData] = useState();

  const [searchValue, setSearchValue] = useState("");
  const [searchList, setSearchList] = useState([]);

  const getEmailTemplate = async () => {
    const response = await templateService.getEmailTemplates();
    if (response.error) {
      if (response.error.code !== 101) {
        toast.error(response.error.message);
      }
    } else {
      setEmailData(response.data || []);
      setSearchList(response.data || []);
    }
    setLoading(false);
  };

  const onRowItemClick = (rowData = null) => {
    templateModal.showModal();
    setTemplateData(rowData);
  };

  const handleSearch = () => {
    setLoading(true);
    if (searchValue === "") {
      setSearchList(emailData || []);
      return;
    }
    const data =
      emailData?.filter((e) =>
        (e.template_name
          ?.toString()
          ?.toUpperCase()
          .match(searchValue?.toUpperCase())||e.purpose_descs
          ?.toString()
          ?.toUpperCase()
          .match(searchValue?.toUpperCase()))
      ) || [];
    setSearchList(data);
    setLoading(false);
  };

  useEffect(() => {
    if (searchValue === "") {
      setSearchList(emailData || []);
    }
  }, [searchValue]);

  useEffect(() => {
    getEmailTemplate();
  }, []);

  return (
    <div>
      <div className="flex-nowrap flex-center justify-content-between">
        <h5>
          Email Templates {emailData?.length > 0 && `(${emailData.length})`}
        </h5>
        {/* <button
          className="btn--sm btn-primary"
          onClick={() => navigate("createemailtemplate")}
        >
          Create Template
        </button> */}
      </div>
      <div className="mt-2">
        <div className="fc-nowrap flex-center justify-content-between mt-4">
          <label className="input input--sm fc-4">
            <input
              type="text"
              id="searchvalue"
              placeholder="Search by Template Name/Purpose of payment"
              value={searchValue}
              onChange={(e) =>
                regexService.isAlphanNumWithChar(e.target.value) &&
                setSearchValue(e.target.value)
              }
            />
            <button
              className="btn--xs btn-primary"
              onClick={() => {
                handleSearch();
              }}
            >
              <span class="material-symbols-rounded">search</span>
            </button>
          </label>
        </div>
        <div className="cover border rounded-border-sm mt-3">
          <table>
            <thead>
              <tr>
                <th>Template Name</th>
                <th>Template ID</th>
                <th>Purpose of Payment</th>
                <th>Created By</th>
                <th>Created on</th>
                {/* <th>Status</th> */}
              </tr>
            </thead>
            {searchList?.length > 0 && (
              <tbody className="table-body">
                {searchList.map((data) => (
                  <tr>
                    <td
                      className="f-500 cursor-pointer"
                      onClick={() => onRowItemClick(data)}
                    >
                      {data.template_name}
                    </td>
                    <td>{data.template_id}</td>
                    <td>{data?.purpose_desc}</td>
                    <td>{data.createdby}</td>
                    <td>{dateFormat(data.createddt)}</td>
                    {/* <td>
                      <StatusChip status={data.isactive} />
                    </td> */}
                  </tr>
                ))}
              </tbody>
            )}
          </table>
          {(isLoading && <div className="no-records">Loading...</div>) ||
            (searchList?.length == 0 && (
              <div className="no-records">No Records to display</div>
            ))}
        </div>
      </div>
      {templateModal.isModal && (
        <Modal>
          <div className="side-modal modal--sm">
            <div className="modal-head border-bottom">
              <h6>Template Details</h6>
              <div className="icon" onClick={templateModal.hideModal}>
                <span class="material-symbols-rounded">close</span>
              </div>
            </div>
            <div className="modal-body py-3">
              <div className="input-wrapper">
                <h6>{templateData?.template_name}</h6>
                <p className="text-2 text-secondary mt-1">
                  <span>ID : </span> {templateData?.template_id}
                </p>
              </div>
              <div className="input-wrapper fc">
                      <p className="title">Purpose of Payment</p>
                      <p>{templateData?.purpose_desc}</p>
                    </div>
              <div className="input-wrapper fc">
                <p className="title">From Name</p>
                <p>{templateData?.from_name}</p>
              </div>
              <div className="input-wrapper fc">
                <p className="title">From ID</p>
                <p>{templateData?.from_email}</p>
              </div>
              <div className="input-wrapper">
                <p className="title">Subject</p>
                <p>{templateData?.mail_subject}</p>
              </div>
              <div className="input-wrapper flex-center justify-content-between">
                <p className="title">Content</p>
                <p
                  className="f-600 text-primary cursor-pointer"
                  onClick={previewModal.showModal}
                >
                  Preview Template
                </p>
              </div>
              <hr />
              <div className="input-wrapper">
                <p className="title">Dynamic Params</p>
                {templateData?.params &&
                  Object.keys(templateData.params)?.map(
                    (e) =>
                      templateData.params[e] && (
                        <div className="input-wrapper">
                          <span className="f-500">{e}</span> -{" "}
                          {templateData.params[e]}
                        </div>
                      )
                  )}
              </div>
            </div>
          </div>
        </Modal>
      )}
      {previewModal?.isModal && (
        <Modal>
          <div className="modal modal--md h-100">
            <div className="modal-head border-bottom">
              <h6>Email Template Preview</h6>
              <div className="icon" onClick={previewModal.hideModal}>
                <span class="material-symbols-rounded">close</span>
              </div>
            </div>
            <div className="modal-body p-0">
              <iframe
                title="email_template_preview"
                srcDoc={templateData?.mail_content}
                className="p-3"
              ></iframe>
            </div>
          </div>
        </Modal>
      )}
    </div>
  );
}

export default EmailList;
